import { HttpErrorResponse } from '@angular/common/http';
import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { catchError, map, of } from 'rxjs';
import { KNOWN_ROUTE_SEGMENTS } from '../../app-routing.module';
import { GroupLinkService } from '../services/group-link.service';

export const groupLinkGuard: CanActivateFn = route => {
  const router = inject(Router);
  const groupLinkService = inject(GroupLinkService);

  const groupLinkParam = route.paramMap.get('groupLink');

  if (!groupLinkParam) {
    return true;
  }

  if (KNOWN_ROUTE_SEGMENTS.includes(groupLinkParam)) {
    return true;
  }

  return groupLinkService.validateGroupLink(groupLinkParam).pipe(
    map(isValid => {
      if (isValid) {
        groupLinkService.setGroupLink(groupLinkParam);
        return true;
      } else {
        router.navigate(['/not-found'], {
          queryParams: {
            reason: 'invalid-group-link',
            groupLink: groupLinkParam,
          },
        });
        return false;
      }
    }),
    catchError((error: HttpErrorResponse) => {
      let reason = 'unknown-error';
      let errorCode: string | undefined;

      if (error.status === 403 || error.status === 404) {
        reason = 'invalid-group-link';
        if (error.error?.error?.code) {
          errorCode = error.error.error.code;
        }
      } else if (error.status === 0) {
        reason = 'network-error';
      }

      router.navigate(['/not-found'], {
        queryParams: {
          reason,
          groupLink: groupLinkParam,
          ...(errorCode && { errorCode }),
        },
      });

      return of(false);
    })
  );
};
